
export function CBEditorNestedAttributes(numberOfLevels = 1) {
    
    const result = (
        _object: object | undefined,
        _context: ClassFieldDecoratorContext | ClassSetterDecoratorContext | ClassGetterDecoratorContext
    ) => {
        
        var asd = 1
        
    }
    
    return result
    
}
